import React from 'react';
import { SdfButton, SdfFocusPane, SdfLink } from '@waypoint/react-components';
import { ZENDESK_LINK } from '../constants';
import languageTranslation from './languageTranslation';

export default function ConsultingModal({ isModalOpen, setIsModalOpen }) {

	const closeModal = () => {
		setIsModalOpen(false);
	};

	return (
		<>
			<SdfFocusPane
				className="text-default"
				paneType="floating"
				visible={isModalOpen}
				closeable={true}
				heading={languageTranslation('common.consultingRequest')}
				dismissOnClickOutside={true}
				hideDismissButton={true}
				hideAcceptButton={true}
				onSdfDismiss={() => {
					closeModal();
				}}
				spacing="loose"
				size="md"
			>
				<div className="text-heading-03">
					{languageTranslation('common.consulting.description.partOne')}
				</div>
				<div className="text-heading-03">
					{languageTranslation('common.consulting.description.partTwo')}
				</div>

				<div className='mt-8 italic text-sm text-secondary'>
					{languageTranslation('common.consulting.note')}
				</div>

				<div slot="custom-buttons">
					<SdfButton className="mr-3" onClick={() => { closeModal() }}>
						{languageTranslation('common.cancel')}
					</SdfButton>
					<SdfLink
						emphasis="primary"
						target='_blank'
						href={ZENDESK_LINK}
						onClick={() => closeModal()}
					>
						{languageTranslation('common.bookConsultation')}
					</SdfLink>
				</div>
			</SdfFocusPane>
		</>
	);
}
